module.exports = __webpack_public_path__ + "static/media/in.317af0e5.jpg";